// handle event for contract new
import { FEE_DATA, NORM_DATA } from "../../../../common/utils/static-data";
import { apiContract } from "../../../../api/api-contract";
import { alert } from "../../../../common/utils/alert";
import { emitter } from "../../../../common/utils/emitter";
import moment from "moment";
//1.submission

export const contractSubmit = (context) => {
  const customerInfoState = context.customerInfo.state;
  const vehicleInfoState = context.vehicleInfo.state;
  const vatFeeState = context.vatFee.state;
  const rentalConditionsState = context.rentalConditions.state;
  const endHalfRatesState = context.endHalfRates.state;

  context.form
    .validateFields()
    .then(async (values) => {
      context.setState({ disabledOk: true }, async () => {
        const {
          weekend_fee,
          holiday_fee,
          driving_weekday_fee,
          driving_holiday_fee,
          driving_weekend_fee,
          contract_code,
          //form array for date
          works_time_holiday,
          works_time,
        } = values;
        const { prefix_code, suffix_code } = contract_code;

        if (!prefix_code || !suffix_code) {
          return alert("error", "Mã hợp đồng là bắt buộc");
        }
        emitter.emit("FETCH_LOADING", true);
        // Xử lý các phần Fee mà không có trong Form

        let costs = FEE_DATA.map((fee) => {
          switch (fee.code) {
            case "CT014":
              return {
                ...fee,
                value: Number(weekend_fee.CT014),
              };
            case "CT005":
              return {
                ...fee,
                value: Number(holiday_fee.CT005),
              };
            case "CT015":
              return {
                ...fee,
                value: Number(driving_weekday_fee.CT015),
              };
            case "CT017":
              return {
                ...fee,
                value: Number(driving_weekend_fee.CT017),
              };
            case "CT016":
              return {
                ...fee,
                value: Number(driving_holiday_fee.CT016),
              };
            default:
              return {
                ...fee,
                value: values[fee.code] ? Number(values[fee.code]) : 0,
              };
          }
        });
        let norms = NORM_DATA.map((norm) => {
          switch (norm.code) {
            case "OLQ007":
              return {
                ...norm,
                value: Number(weekend_fee.OLQ007),
              };
            case "OLQ006":
              return {
                ...norm,
                value: Number(holiday_fee.OLQ006),
              };
            case "OLQ002":
              return {
                ...norm,
                value: Number(driving_weekday_fee.OLQ002),
              };
            case "OLQ004":
              return {
                ...norm,
                value: Number(driving_weekend_fee.OLQ004),
              };
            case "OLQ003":
              return {
                ...norm,
                value: Number(driving_holiday_fee.OLQ003),
              };
            default:
              return {
                ...norm,
                value: values[norm.code] ? Number(values[norm.code]) : 0,
              };
          }
        });

        // Lấy tất cả dữ liệu có trong Form + Các state trong component cần thiết + Convert các Range Date thành date
        let payload = {
          member_customer_id: customerInfoState.user.id,
          customer_id: customerInfoState.customer_info.customer_id,
          driver_id: vehicleInfoState.driver_info
            ? vehicleInfoState.driver_info.id
            : null,
          vehicle_id: vehicleInfoState.vehicle_info
            ? vehicleInfoState.vehicle_info.id
            : null,
          parking_id: vehicleInfoState.parking_id,
          driver_know_english: vehicleInfoState.driver_know_english,
          vat_toll_fee: vatFeeState.vat_toll_fee,
          include_empty_km: rentalConditionsState.include_empty_km,
          return_vehicle_early: rentalConditionsState.return_vehicle_early,
          time_use_policy_group_id: endHalfRatesState.time_use_policy_group_id,
          //lay tu state
          // lay tu form
          ...values,
          punishment: Number(values.punishment),
          vehicle_working_area: values.vehicle_working_area.trim(),
          sign_date: values.sign_date.startOf("day").valueOf(),
          from_datetime: values.from_datetime.startOf("day").valueOf(),
          to_datetime: values.to_datetime.startOf("day").valueOf(),
          working_time_from: works_time[0].format("HH:mm:ss"),
          working_time_to: works_time[1].format("HH:mm:ss"),
          working_time_weekend_holiday_from: works_time_holiday[0].format(
            "HH:mm:ss"
          ),
          working_time_weekend_holiday_to: works_time_holiday[1].format(
            "HH:mm:ss"
          ),
          costs,
          norms,
          prefix_code,
          suffix_code,
        };

        try {
          let idEdit = null;
          let func = apiContract.createContract;
          if (context.state.editPage) {
            if (context.state.unlimitEdit) {
              func = apiContract.editImmediateContract;
            } else {
              func = apiContract.editEffectiveDateContract;
              payload.effective_date = values.effective_date
                ? values.effective_date.startOf("day").valueOf()
                : null;
            }
            idEdit = context.contractParam.id;
          }

          if (
            context.state.editPage &&
            context.state.limitEdit &&
            context.state.unlimitEdit
          ) {
            scrollTopContract();
            alert("success", "Chỉnh sửa hợp đồng thành công");
            context.props.close();
            return;
          }
          const result = await func(payload, idEdit);
          emitter.emit("FETCH_LOADING", false);
          if (result.status === "success") {
            context.setState({ disabledOk: false });
            let new_suffix_code = Number(suffix_code) + 1;
            if (new_suffix_code < 10) {
              new_suffix_code = `00${new_suffix_code}`;
            } else if (new_suffix_code >= 10 && new_suffix_code < 100) {
              new_suffix_code = `0${new_suffix_code}`;
            }
            scrollTopContract();
            if (context.state.editPage) {
              alert("success", "Chỉnh sửa hợp đồng thành công");
              context.props.close();
            } else {
              context.successModal.changeVisible(
                true,
                `${prefix_code} - ${suffix_code}`,
                () =>
                  context.addVehicleInSuccess({
                    code: prefix_code,
                    suffix_code: new_suffix_code,
                  }),
                context.addNewContractSuccess,
                context.props.close
              );
            }
          } else {
            context.setState({ disabledOk: false });
            alert("error", result.data.message);
          }
        } catch (error) {
          context.setState({ disabledOk: false });
          emitter.emit("FETCH_LOADING", false);
          alert("error", "Network Error");
        }
      });
    })
    .catch((info) => {
      emitter.emit("FETCH_LOADING", false);
      scrollTopContract();
      // Khi xảy ra validation error thì scroll về đầu trang
    });
};

const scrollTopContract = () => {
  const element = document.getElementById("right-layout");
  element.scrollTo(0, 0);
};

export const convertContract = (contract, context, editPage) => {
  if (contract.contract_code) {
    context.contractCode.setState({
      ...contract.contract_code,
    });
  }
  // setState cho các component cần thay đổi state lúc mới vào và ko có trong Form
  context.customerInfo.setState({
    customer_info: contract.customer
      ? contract.customer
      : {
          company_name: "",
          id: -1,
          customer_id: -1,
          tax_code: "",
          customer_info: "",
        },
    isDisableUser: contract.customer ? false : true,
    user: contract.member_customer
      ? contract.member_customer
      : {
          phone_number: "",
          email: "",
        },
    optionsCompany: [],
    optionsUser: [],
  });
  if (editPage) {
    context.vehicleInfo.oldVehicle = contract.vehicle;
    context.vehicleInfo.oldDriver = contract.driver;
    context.vehicleInfo.init_driver_know_english = contract.driver_know_english;
    context.vehicleInfo.init_parking_id = contract.parking_id;
    context.vehicleInfo.setState({
      driver_know_english:
        contract.driver_know_english !== undefined
          ? contract.driver_know_english
          : true,
      parking_id: contract.parking_id ? contract.parking_id : 1,
      optionsVehicle: contract.vehicle
        ? [{ ...contract.vehicle, value: contract.vehicle.number_plate }]
        : [],
      optionsDriver: contract.driver
        ? [
            {
              ...contract.driver,
              value: `${contract.driver.name} - ${contract.driver.mobile}`,
            },
          ]
        : [],
      vehicle_info: contract.vehicle
        ? contract.vehicle
        : {
            color: "",
            contract_contained: null,
            id: null,
            model: "",
            number_plate: "",
            type: "",
          },
      required: contract.vehicle ? true : false, // Khi edit page nếu có tài và xe rồi thì bắt buộc phải có
      driver_info: contract.driver
        ? contract.driver
        : {
            contract_contained: null,
            email: "",
            id: null,
            id_card: "",
            name: "",
            phone_number: "",
          },
    });
  } else {
    context.vehicleInfo.setState({
      driver_know_english:
        contract.driver_know_english !== undefined
          ? contract.driver_know_english
          : true,
      parking_id: contract.parking_id ? contract.parking_id : 1,
      optionsDriver: [],
      optionsVehicle: [],
      vehicle_info: {
        color: "",
        contract_contained: null,
        id: null,
        model: "",
        number_plate: "",
        type: "",
      },
      driver_info: {
        contract_contained: null,
        email: "",
        id: null,
        id_card: "",
        name: "",
        phone_number: "",
      },
    });
  }

  context.rentalConditions.setState({
    isflexibleWorkingDay:
      contract.working_day && contract.working_day.id === 6 ? true : false,
    return_vehicle_early:
      contract.return_vehicle_early !== undefined
        ? contract.return_vehicle_early
        : 1,
    include_empty_km:
      contract.is_include_empty_km !== undefined
        ? contract.is_include_empty_km
        : true,
  });

  context.vatFee.setState({
    vat_toll_fee:
      contract.vat_toll_fee !== undefined ? contract.vat_toll_fee : 0,
  });

  // context.rentalConditions.setState({

  // });

  context.rentalConditions.init_include_empty_km = contract.is_include_empty_km; // set vao init value de check khi change
  context.rentalConditions.return_vehicle_early = contract.return_vehicle_early;

  context.endHalfRates.setState({
    time_use_policy_group_id: contract.time_use_policy_group_id
      ? contract.time_use_policy_group_id
      : 0,
  });

  context.endHalfRates.init_time_use_policy_group_id =
    contract.time_use_policy_group_id; // set vao init value de check khi change

  const {
    working_time_weekend_holiday_from,
    working_time_weekend_holiday_to,
    working_time_from,
    working_time_to,
    from_datetime,
    to_datetime,
    branch,
    costs,
    norms,
  } = contract;

  // Xử lý các customize Form.Item gồm Range Date, Double Input

  let works_time_holiday = [moment("07:00", "HH:mm"), moment("18:00", "HH:mm")];
  let works_time = [moment("07:00", "HH:mm"), moment("18:00", "HH:mm")];
  if (working_time_weekend_holiday_from || working_time_weekend_holiday_to) {
    works_time_holiday[0] = moment(
      working_time_weekend_holiday_from,
      "HH:mm:ss"
    );
    works_time_holiday[1] = moment(working_time_weekend_holiday_to, "HH:mm:ss");
  } else {
    works_time_holiday = contract.works_time_holiday
      ? contract.works_time_holiday
      : null;
  }

  if (working_time_from || working_time_to) {
    works_time[0] = moment(working_time_from, "HH:mm:ss");
    works_time[1] = moment(working_time_to, "HH:mm:ss");
  } else {
    works_time = contract.works_time ? contract.works_time : null;
  }

  // Lấy dữ liệu đổ vào Form gồm các Param được Form sử dụng để call api

  let dataForm = {
    CT001: 0,
    CT002: 0,
    CT003: 0,
    holiday_fee: {
      CT005: 0,
      OLQ006: 100,
    },
    CT006: 0,
    CT018: 0,
    driving_weekday_fee: {
      CT015: 0,
      OLQ002: 200,
    },
    driving_holiday_fee: {
      CT016: 0,
      OLQ003: 200,
    },
    driving_weekend_fee: {
      CT017: 0,
      OLQ004: 200,
    },
    weekend_fee: {
      CT014: 0,
      OLQ007: 100,
    },
    OLQ001: 0,
    OLQ005: 0,
    CT020: 0,
    return_vehicle_early: contract.return_vehicle_early
      ? contract.return_vehicle_early
      : false,
    customer_info: contract.customer ? contract.customer.name : "",
    user: contract.member_customer ? contract.member_customer.name : "",
    vehicle_info: editPage
      ? contract.vehicle
        ? contract.vehicle.number_plate
        : ""
      : "",
    driver_info: editPage
      ? contract.driver
        ? `${contract.driver.name}`
        : ""
      : "",
    works_time,
    works_time_holiday,
    branch_code: branch ? branch.code : null,

    sign_date: contract.sign_date ? moment(contract.sign_date) : null,
    from_datetime: moment(from_datetime),
    to_datetime: moment(to_datetime),
    deposit: contract.deposit ? contract.deposit : 0,
    payment_term: contract.payment_term ? contract.payment_term : 0,
    working_day_value:
      contract.working_day && contract.working_day.id === 6
        ? contract.working_day_value
        : "",
    days_inform_before_return_vehicle: contract.days_inform_before_return_vehicle
      ? contract.days_inform_before_return_vehicle
      : 0,
    penalty_rate_early_termination: contract.penalty_rate_early_termination
      ? Number(contract.penalty_rate_early_termination)
      : 0,
    note: contract.note ? contract.note : 0,
    fuel_type_code: contract.fuel_type ? contract.fuel_type.code : null,
    rental_service_type_code: contract.rental_service_type
      ? contract.rental_service_type.code
      : null,
    working_day_code: contract.working_day ? contract.working_day.code : null,
    vehicle_working_area: contract.vehicle_working_area
      ? contract.vehicle_working_area
      : "",
    contract_code: contract.contract_code
      ? contract.contract_code
      : {
          prefix_code: "",
          suffix_code: "001",
        },
    fuel_adjust_percent: contract.fuel_adjust_percent
      ? contract.fuel_adjust_percent.toFixed(2)
      : 0,
  };

  costs &&
    costs.forEach((cost) => {
      switch (cost.code) {
        case "CT014":
          return (dataForm["weekend_fee"].CT014 = cost.value);
        case "CT005":
          return (dataForm["holiday_fee"].CT005 = cost.value);
        case "CT015":
          return (dataForm["driving_weekday_fee"].CT015 = cost.value);
        case "CT017":
          return (dataForm["driving_weekend_fee"].CT017 = cost.value);
        case "CT016":
          return (dataForm["driving_holiday_fee"].CT016 = cost.value);
        default:
          return (dataForm[cost.code] = cost.value);
      }
    });

  norms &&
    norms.forEach((norm) => {
      switch (norm.code) {
        case "OLQ007":
          return (dataForm["weekend_fee"].OLQ007 = norm.value);
        case "OLQ006":
          return (dataForm["holiday_fee"].OLQ006 = norm.value);
        case "OLQ002":
          return (dataForm["driving_weekday_fee"].OLQ002 = norm.value);
        case "OLQ004":
          return (dataForm["driving_weekend_fee"].OLQ004 = norm.value);
        case "OLQ003":
          return (dataForm["driving_holiday_fee"].OLQ003 = norm.value);
        case "OLQ001":
          return (dataForm["OLQ001"] = norm.value);
        case "OLQ005":
          return (dataForm["OLQ005"] = norm.value.toFixed(1));
        default:
      }
    });
  context.form.setFieldsValue({ ...dataForm, effective_date: null });
  context.initFormValue = dataForm;
};

export const initValues = (isDefault = true) => {
  return {
    CT001: 0,
    CT002: 0,
    CT003: 0,
    holiday_fee: {
      CT005: 0,
      OLQ006: 100,
    },
    CT006: 0,
    CT018: 0,
    CT020: 0,
    driving_weekday_fee: {
      CT015: 0,
      OLQ002: 200,
    },
    driving_holiday_fee: {
      CT016: 0,
      OLQ003: 200,
    },
    driving_weekend_fee: {
      CT017: 0,
      OLQ004: 200,
    },
    weekend_fee: {
      CT014: 0,
      OLQ007: 100,
    },
    OLQ001: 0,
    OLQ005: 0,
    fuel_adjust_percent: 0,
    return_vehicle_early: true,
    works_time: [moment("07:00", "HH:ss"), moment("18:00", "HH:ss")], // work time from and work time to
    works_time_holiday: [moment("07:00", "HH:ss"), moment("18:00", "HH:ss")], // work time from and work time to
    branch_code: "",
    sign_date: moment(),
    from_datetime: moment().add(1, "day"),
    to_datetime: moment().add(2, "day"),
    deposit: 0,
    payment_term: 0,
    working_day_value: "",
    days_inform_before_return_vehicle: 0,
    penalty_rate_early_termination: 0,
    note: "",
    contract_code: null,
  };
};

const checkSameValue = (context) => {
  const values = context.form.getFieldsValue();
  const initValues = context.initFormValue;
  let checkIndex = 0;
  const keys = Object.keys(values);

  keys.forEach((key) => {
    switch (key) {
      case "branch_code":
      case "vehicle_working_area":
      case "sign_date":
      case "vehicle_info":
      case "driver_info":
      case "deposit":
      case "payment_term":
      case "fuel_type_code":
      case "days_inform_before_return_vehicle":
      case "penalty_rate_early_termination":
      case "from_datetime":
      case "to_datetime":
      case "note":
        if (
          (!initValues[key] && values[key]) ||
          (initValues[key] &&
            JSON.stringify(initValues[key]) !== JSON.stringify(values[key]))
        ) {
          checkIndex = 1;
        }
        break;
      default:
        if (
          (!initValues[key] && values[key]) ||
          (initValues[key] &&
            JSON.stringify(initValues[key]) !== JSON.stringify(values[key]))
        ) {
          checkIndex = 2;
        }
        break;
    }
  });

  if (checkIndex === 1) {
    context.setState(
      {
        limitEdit: false,
        unlimitEdit: true,
      },
      () => context.form.validateFields(["effective_date"])
    );
  } else if (checkIndex === 2) {
    context.setState(
      {
        limitEdit: true,
        unlimitEdit: false,
      },
      () => context.form.validateFields(["effective_date"])
    );
  } else {
    // const init_time_use_policy_group_id = context.endHalfRates.init_time_use_policy_group_id;
    // const init_include_empty_km = context.rentalConditions.init_include_empty_km;
    // const { time_use_policy_group_id } = context.endHalfRates.state;
    // const { include_empty_km } = context.rentalConditions.state;
    const { init_driver_know_english, init_parking_id } = context.vehicleInfo;
    const { driver_know_english, parking_id } = context.vehicleInfo.state;
    const init_return_vehicle_early =
      context.rentalConditions.return_vehicle_early;
    const { return_vehicle_early } = context.rentalConditions.state;
    if (
      init_driver_know_english !== driver_know_english ||
      init_parking_id !== parking_id ||
      init_return_vehicle_early !== (return_vehicle_early ? true : false)
    ) {
      return context.setState(
        {
          limitEdit: false,
          unlimitEdit: true,
        },
        () => context.form.validateFields(["effective_date"])
      );
    }
    context.setState(
      {
        limitEdit: true,
        unlimitEdit: true,
      },
      () => context.form.validateFields(["effective_date"])
    );

    //func && func();
    //, () => context.form.validateFields(['effective_date']) sẽ check cho trường effective_date khi đổi qua lại giữa các lần NGÀY HIỆU LỰC
  }
};

export const checkChangeFormValue = (context, func) => {
  checkSameValue(context, func);
};
